import { render, staticRenderFns } from "./SlideView.vue?vue&type=template&id=eb65d5d4&scoped=true&"
import script from "./SlideView.vue?vue&type=script&lang=js&"
export * from "./SlideView.vue?vue&type=script&lang=js&"
import style0 from "./SlideView.vue?vue&type=style&index=0&id=eb65d5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb65d5d4",
  null
  
)

export default component.exports